import React from 'react';
import {
    LeftNavigation,
    LeftNavigationBody,
    LeftNavigationHeader,
    LeftNavigationItem,
    LeftNavigationItemContent, LeftNavigationItemMenu,
    LeftNavigationPanel,
} from "@tag/tag-components-react-v4";
import {Link, Outlet, useLocation} from 'react-router-dom';
import {
    AddUserFilled,
    CircleInfoFilled,
    CircleInfoLined, DatabaseFilled, DayviewLined, DocList2Filled, DownloadFilled,
    Email2Filled,
    ExitFilled,
    HourglassFullFilled,
    LinkFilled,
    PinFilled, UserMenuMaleLined,
    UserSettingsFilled,
    UsersFilled,
    WeatherCloudFilled,
    WindmillFilled
} from "@tag/tag-icons";
import styles from './SelfServiceTemplate.module.scss'
import AppRolesService from "./General/services/AppRolesService";
import {useIsAuthenticated, useMsal} from "@azure/msal-react";

const SelfServiceTemplate = () => {

    const location = useLocation();
    const { accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    
    let isAdmin = AppRolesService.isUserAdmin(accounts, isAuthenticated);
    let canCreateEnv = AppRolesService.canUserCreateEnvironments(accounts, isAuthenticated);
    let canRetrieveDbBackups = AppRolesService.canUserRetrieveDbBackups(accounts, isAuthenticated);
    
    const generateAdminOptions = () => {
        return (
            <LeftNavigationItemMenu className={'SideNavPanelSelfServiceMenu'} icon={<PinFilled />} text="Admin Tools">
                <LeftNavigationItem name="/admin/info">
                    <Link to="/admin/info" style={{ textDecoration: 'none', width: '100%' }}>
                        <LeftNavigationItemContent name="/admin/info" icon={<CircleInfoLined />} text="Admin Info" indent={1} />
                    </Link>
                </LeftNavigationItem>
                <LeftNavigationItem name="/admin/signinlogs">
                    <Link to="/admin/signinlogs" style={{ textDecoration: 'none', width: '100%' }}>
                        <LeftNavigationItemContent name="/admin/signinlogs" icon={<UserMenuMaleLined />} text="Sign In Logs" indent={1} />
                    </Link>
                </LeftNavigationItem>
                <LeftNavigationItem name="/admin/activitylogs">
                    <Link to="/admin/activitylogs" style={{ textDecoration: 'none', width: '100%' }}>
                        <LeftNavigationItemContent name="/admin/activitylogs" icon={<DayviewLined />} text="Activity Logs" indent={1} />
                    </Link>
                </LeftNavigationItem>
            </LeftNavigationItemMenu>
        );
    }

    let canConfigureACC = AppRolesService.canUserConfigureACC(accounts, isAuthenticated);
    let canManageSurveyJSTemplates = AppRolesService.canUserManageSurveyJSTemplates(accounts, isAuthenticated);
    let canAccessTelemetry = AppRolesService.canAccessTelemetryData(accounts, isAuthenticated);

    const generateCareComplianceOptions = () => {
        return (
            <LeftNavigationItemMenu className={'SideNavPanelSelfServiceMenu'} icon={<PinFilled />} text="Care Compliance">
                <LeftNavigationItem name="/carecompliance/customers">
                    <Link to="/carecompliance/customers" style={{ textDecoration: 'none', width: '100%' }}>
                        <LeftNavigationItemContent name="/carecompliance/customers" icon={<UsersFilled />} text="Customer List" indent={1} />
                    </Link>
                </LeftNavigationItem>
                <LeftNavigationItem name="/carecompliance/internaladmintool">
                    <Link to="/carecompliance/internaladmintool" style={{ textDecoration: 'none', width: '100%' }}>
                        <LeftNavigationItemContent name="/carecompliance/internaladmintool" icon={<UserSettingsFilled />} text="Internal Admin Tool" indent={1} />
                    </Link>
                </LeftNavigationItem>
                <LeftNavigationItem name="/carecompliance/dataexports">
                    <Link to="/carecompliance/dataexports" style={{ textDecoration: 'none', width: '100%' }}>
                        <LeftNavigationItemContent name="/carecompliance/dataexports" icon={<DownloadFilled />} text="Data Exports" indent={1} />
                    </Link>
                </LeftNavigationItem>
                <LeftNavigationItem name="/carecompliance/terminations">
                    <Link to="/carecompliance/terminations" style={{ textDecoration: 'none', width: '100%' }}>
                        <LeftNavigationItemContent name="/carecompliance/terminations" icon={<HourglassFullFilled />} text="Terminations" indent={1} />
                    </Link>
                </LeftNavigationItem>
                {
                    canAccessTelemetry ?
                        <LeftNavigationItem name="/carecompliance/usagetelemetry">
                            <Link to="/carecompliance/usagetelemetry" style={{ textDecoration: 'none', width: '100%' }}>
                                <LeftNavigationItemContent name="/carecompliance/usagetelemetry" icon={<DocList2Filled />} text="Usage Telemetry" indent={1} />
                            </Link>
                        </LeftNavigationItem> : <></>
                }
                {
                    canConfigureACC ?
                        <LeftNavigationItem name="/carecompliance/createcustomer">
                            <Link to="/carecompliance/createcustomer" style={{ textDecoration: 'none', width: '100%' }}>
                                <LeftNavigationItemContent name="/carecompliance/createcustomer" icon={<AddUserFilled />} text="Create Customer" indent={1} />
                            </Link>
                        </LeftNavigationItem> : <></>
                }
                {
                    canManageSurveyJSTemplates ?
                        <LeftNavigationItem name="/carecompliance/surveyjstemplates">
                            <Link to="/carecompliance/surveyjstemplates" style={{ textDecoration: 'none', width: '100%' }}>
                                <LeftNavigationItemContent name="/carecompliance/surveyjstemplates" icon={<DocList2Filled />} text="SurveyJS Templates" indent={1} />
                            </Link>
                        </LeftNavigationItem> : <></>
                }
            </LeftNavigationItemMenu>
        );
    }

    const generatePoliciesAndProceduresOptions = () => {
        return (
            <LeftNavigationItemMenu className={'SideNavPanelSelfServiceMenu'} icon={<PinFilled />} text="Policies & Procedures">
                <LeftNavigationItem name="/policiesandprocedures/organisations">
                    <Link to="/policiesandprocedures/organisations" style={{ textDecoration: 'none', width: '100%' }}>
                        <LeftNavigationItemContent name="/policiesandprocedures/organisations" icon={<UsersFilled />} text="Organisation List" indent={1} />
                    </Link>
                </LeftNavigationItem>
                <LeftNavigationItem name="/policiesandprocedures/terminations">
                    <Link to="/policiesandprocedures/terminations" style={{ textDecoration: 'none', width: '100%' }}>
                        <LeftNavigationItemContent name="/policiesandprocedures/terminations" icon={<HourglassFullFilled />} text="Terminations" indent={1} />
                    </Link>
                </LeftNavigationItem>
                {
                    canAccessTelemetry ?
                        <LeftNavigationItem name="/policiesandprocedures/usagetelemetry">
                            <Link to="/policiesandprocedures/usagetelemetry" style={{ textDecoration: 'none', width: '100%' }}>
                                <LeftNavigationItemContent name="/policiesandprocedures/usagetelemetry" icon={<DocList2Filled />} text="Usage Telemetry" indent={1} />
                            </Link>
                        </LeftNavigationItem> : <></>
                }
            </LeftNavigationItemMenu>
        );
    }
    
    const generatePeoplePlannerOptions = () => {
        return (
            <LeftNavigationItemMenu icon={<PinFilled />} text="People Planner" className={'SideNavPanelSelfServiceMenu'}>
                <LeftNavigationItem name="/peopleplanner/customers">
                    <Link to="/peopleplanner/customers" style={{ textDecoration: 'none', width: '100%' }}>
                        <LeftNavigationItemContent name="/peopleplanner/customers" icon={<UsersFilled />} text="Customer List" indent={1} />
                    </Link>
                </LeftNavigationItem>
                <LeftNavigationItem name="/peopleplanner/terminations">
                    <Link to="/peopleplanner/terminations" style={{ textDecoration: 'none', width: '100%' }}>
                        <LeftNavigationItemContent name="/peopleplanner/terminations" icon={<HourglassFullFilled />} text="Terminations" indent={1} />
                    </Link>
                </LeftNavigationItem>
                <LeftNavigationItem name="/peopleplanner/dataexports">
                    <Link to="/peopleplanner/dataexports" style={{ textDecoration: 'none', width: '100%' }}>
                        <LeftNavigationItemContent name="/peopleplanner/dataexports" icon={<DownloadFilled />} text="Data Exports" indent={1} />
                    </Link>
                </LeftNavigationItem>
                <LeftNavigationItem name="/peopleplanner/appgroups">
                    <Link to="/peopleplanner/appgroups" style={{ textDecoration: 'none', width: '100%' }}>
                        <LeftNavigationItemContent name="/peopleplanner/appgroups" icon={<WeatherCloudFilled  />} text="App Groups" indent={1} />
                    </Link>
                </LeftNavigationItem>
                {
                    canCreateEnv ?
                        <LeftNavigationItem name="/peopleplanner/createenvironment">
                            <Link to="/peopleplanner/createenvironment" style={{ textDecoration: 'none', width: '100%' }}>
                                <LeftNavigationItemContent name="/peopleplanner/createenvironment" icon={<AddUserFilled />} text="Create Tenant" indent={1} />
                            </Link>
                        </LeftNavigationItem> : <></>
                }
                {
                    isAdmin ?
                        <LeftNavigationItem name="/peopleplanner/appoctosync">
                            <Link to="/peopleplanner/appoctosync" style={{ textDecoration: 'none', width: '100%' }}>
                                <LeftNavigationItemContent name="/peopleplanner/appoctosync" icon={<WindmillFilled />} text="APP Octopus Sync" indent={1} />
                            </Link>
                        </LeftNavigationItem> : <></>
                }
                {
                    isAdmin ?
                        <LeftNavigationItem name="/peopleplanner/applinkdb">
                            <Link to="/peopleplanner/applinkdb" style={{ textDecoration: 'none', width: '100%' }}>
                                <LeftNavigationItemContent name="/peopleplanner/applinkdb" icon={<LinkFilled />} text="APP Link Database" indent={1} />
                            </Link>
                        </LeftNavigationItem> : <></>
                }
                {
                    canRetrieveDbBackups ?
                        <LeftNavigationItem name="/peopleplanner/dbbackups">
                            <Link to="/peopleplanner/dbbackups" style={{ textDecoration: 'none', width: '100%' }}>
                                <LeftNavigationItemContent name="/peopleplanner/dbbackups" icon={<DatabaseFilled />} text="DB Backups" indent={1} />
                            </Link>
                        </LeftNavigationItem> : <></>
                }
            </LeftNavigationItemMenu>
        );
    }

    const generateBottomOptions = () => {
        return (
            <LeftNavigationPanel className={'SideNavPanelSelfServiceMenu'} style={{ marginTop: 'auto', borderTop: '1px solid #e7e7e7' }}>
                <LeftNavigationItem name="/info">
                    <Link to="/info" style={{ textDecoration: 'none', width: '100%' }}>
                        <LeftNavigationItemContent name="/info" icon={<CircleInfoFilled />} text="Info" />
                    </Link>
                </LeftNavigationItem>
                <LeftNavigationItem name="/contact">
                    <Link to="/contact" style={{ textDecoration: 'none', width: '100%' }}>
                        <LeftNavigationItemContent name="/contact" icon={<Email2Filled />} text="Contact" />
                    </Link>
                </LeftNavigationItem>
                <LeftNavigationItem name="/logout">
                    <Link to="/logout" style={{ textDecoration: 'none', width: '100%' }}>
                        <LeftNavigationItemContent name="/logout" icon={<ExitFilled />} text="Logout" />
                    </Link>
                </LeftNavigationItem>
            </LeftNavigationPanel>
        );
    }

    let content = null;
    content = (
        <div className={styles.Container}>
            <div>
                <LeftNavigation className={styles.TemplateNavBar} collapsable={true} collapsed={true}
                                selectedItem={location.pathname}>
                    <LeftNavigationHeader>HSC Self Service Tools</LeftNavigationHeader>
                    <LeftNavigationBody style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
                        {
                            generatePeoplePlannerOptions()
                        }
                        {
                            generateCareComplianceOptions()
                        }
                        {
                            generatePoliciesAndProceduresOptions()
                        }
                        {
                            isAdmin ? generateAdminOptions() : <></>
                        }
                        {
                            generateBottomOptions()
                        }
                    </LeftNavigationBody>
                </LeftNavigation>
            </div>
            <div className={styles.PageContent}>
                <Outlet/>
            </div>
        </div>
    );

    return (
        <>
            {content}
        </>
    );
}

export default SelfServiceTemplate;
